import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a1ebc64afefc00014bf670e_1780403657451/printhub/src/app/about/page.tsx");
